export const INTERNAL_USER_EMAIL_PATTERNS = [
  /@scalekit\.com$/i,
  /@scalekit\.pro$/i,
  /testskit9/i,
  /\+sktest/i,
  /amit\.ash/i,
  /kuntal\+testutk/i,
  /shrimithranr/i,
  /avinashmkamath/i,
  /satya\+test/i,
  /anujsharma/i,
  /avinashkam/i,
  /saif\.shines/i,
  /@infrasity\.com$/i,
  /jitender\.rana/i,
  /srinvaskarra/i,
  /tamilram/i,
  /banerjee\.kuntal/i,
  /nityaypm/i,
  /nityaprint19/i,
  /intakshay03/i,
  /kuntal\+testwidth1234/i,
  /test\+nitya/i,
  /nityashree\.y/i,
  /dhaneshbabu/i,
  /akshaypoetree/i,
  /akshaysuresh49/i,
  /akshay\.parihar/i,
  /rachit_d/i,
  /saravanasundar/i,
  /^saravanan@gmail\.com$/i,
  /^aadhisivaraj@gmail\.com$/i,
  /^aathysiv@gmail\.com$/i,
  /diwakarrachit84/i,
  /saifshine7/i,
  /mohit\.dalal/i,
  /^vamsidhar\.test@gmail\.com$/i,
  /nitya19\+test/i,
  /nitya1print19/i,
  /testskituser/i,
  /rvamsidhar1302/i,
  /rexlosthismind/i,
  /^mabnuxr@gmail\.com$/i,
  /^rjmohan535@gmail\.com$/i
];
